
export type AspectRatio = `${number}${':' | '/'}${number}` | [number, number] | `ratio-${number}-${number}`;
export const parseAspectRatio = (ratio: AspectRatio) => {
  if (Array.isArray(ratio)) {
    return ratio[0] / ratio[1];
  }
  let c: number[];
  if (ratio.indexOf('ratio-') > -1) {
    c = ratio.replace('ratio-', '').split('-').map(Number);
    return c![0] / c![1];
  }
  if (ratio.indexOf('/') > -1) {
    c = ratio.split('/').map(Number);
    return c![0] / c![1];
  }
  if (ratio.indexOf(':') > -1) {
    c = ratio.split(':').map(Number);
    return c![0] / c![1];
  }
}
